import type { EdgeCheckoutMode } from '@benzinga/ads-utils';
import type { EdgeCheckoutOpenOptions } from './edgeCheckoutController';

export type CheckoutTrackingExtras = {
  amount?: number;
  checkout_mode?: EdgeCheckoutMode;
  checkout_session_id?: string;
  duration_ms?: number;
};

type CheckoutTrackingSource = Pick<
  EdgeCheckoutOpenOptions,
  'checkoutParams' | 'checkoutType' | 'paywallId' | 'placement'
>;

export const createCheckoutSessionId = (): string => crypto.randomUUID();

export const buildCheckoutEventProperties = (checkout: CheckoutTrackingSource, extras?: CheckoutTrackingExtras) => ({
  amount: extras?.amount,
  checkout_mode: extras?.checkout_mode,
  checkout_session_id: extras?.checkout_session_id,
  checkout_type: checkout.checkoutType,
  duration_ms: extras?.duration_ms,
  package_id: checkout.paywallId,
  page_url: window.location.href,
  placement: checkout.placement,
  product_id: 'edge',
  utm_ad: checkout.checkoutParams.ad,
  utm_ad_type: checkout.checkoutParams.adType,
  utm_campaign: checkout.checkoutParams.campaign,
});
